
export const CSV = 'text/csv'
